import { render, staticRenderFns } from "./SelectLocalProductModal.vue?vue&type=template&id=057fac52&"
import script from "./SelectLocalProductModal.vue?vue&type=script&lang=js&"
export * from "./SelectLocalProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports